import { useMutation } from "react-query";

import { useCombinationRules } from "./useCombinationRules";

interface MutateOptions {
  onSuccess?: (data?: any) => void;
  onError?: (error: any) => void;
}

interface DataIProps {
  options?: MutateOptions;
}

/** Массовая проверка карточек сотрудников (POST /rules/check-all). */
export const useCheckAllCombinationRules = () => {
  const { rulesCheckAll } = useCombinationRules();

  const mutation = useMutation({
    mutationFn: async (props: DataIProps) => {
      await rulesCheckAll();
      return props;
    },
    onSuccess: (data, { options }) => {
      options?.onSuccess?.(data);
    },
    onError: (error, { options }) => {
      options?.onError?.(error);
    },
  });

  const checkAll = (options?: MutateOptions) => {
    mutation.mutate({ options });
  };

  return { checkAll, isLoading: mutation.isLoading };
};
